module.exports = __webpack_public_path__ + "img/translator-CH.ac4fc6f.svg";